var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2351 2.41846H14.2351V0.418457H12.2351V2.41846H6.23511V0.418457H4.23511V2.41846H2.23511C1.13211 2.41846 0.235107 3.31546 0.235107 4.41846V18.4185C0.235107 19.5215 1.13211 20.4185 2.23511 20.4185H16.2351C17.3381 20.4185 18.2351 19.5215 18.2351 18.4185V4.41846C18.2351 3.31546 17.3381 2.41846 16.2351 2.41846ZM16.2371 18.4185H2.23511V6.41846H16.2351L16.2371 18.4185Z",
    fill: "#FF4B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23508 15.8324L13.9421 10.1254L12.5281 8.71143L8.23508 13.0044L5.94208 10.7114L4.52808 12.1254L8.23508 15.8324Z",
    fill: "#FF4B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.32f969ff168409b18788331b46eb10b8.svg";
export { ForwardRef as ReactComponent };